import { EDITOR_TOGGLE_PAGE_MODAL } from './constants';

export function togglePageModal() {
  return {
    type: EDITOR_TOGGLE_PAGE_MODAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_TOGGLE_PAGE_MODAL:
      return {
        ...state,
        togglePageModal: !state.togglePageModal,
        showBuilderCanvasLoader: !state.showBuilderCanvasLoader,
      };

    default:
      return state;
  }
}
